import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}






(function(){
  function refresh(){ document.dispatchEvent(new CustomEvent('cart:refresh')); }

  function groupUpdate(gid, cb){
    if(!gid) return cb();
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      const updates = {};
      cart.items.forEach(it=>{
        if(it.properties && it.properties._group_id === gid) cb(updates, it);
      });
      return fetch('/cart/update.js',{
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ updates })
      });
    }).then(refresh).catch(console.error);
  }

  // remove (parent + child if grouped)
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-remove-key]');
    if(!btn) return;
    const key = btn.dataset.removeKey;
    const gid = btn.dataset.removeGroup;
    e.preventDefault();

    if(!gid){
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
        .then(refresh).catch(console.error);
    } else {
      groupUpdate(gid, (updates,it)=>{ updates[it.key]=0; });
    }
  });

  // quantity +/- and manual input (sync group)
  function changeQty(key,gid,qty){
    if(!gid){
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(refresh);
    }
    return groupUpdate(gid, (updates,it)=>{ updates[it.key]=qty; });
  }

  document.addEventListener('click', function(e){
    const minus = e.target.closest('.cd-qty.minus');
    const plus  = e.target.closest('.cd-qty.plus');
    if(!minus && !plus) return;
    const wrap = e.target.closest('[data-key]');
    const input = wrap.querySelector('.cd-qty.input');
    const key = input.dataset.key;
    const gid = input.dataset.group;
    const cur = Math.max(0, parseInt(input.value||'1',10));
    const next = minus ? Math.max(0, cur-1) : cur+1;
    input.value = next;
    changeQty(key,gid,next).catch(console.error);
  });

  document.addEventListener('change', function(e){
    const input = e.target.closest('.cd-qty.input');
    if(!input) return;
    const key = input.dataset.key;
    const gid = input.dataset.group;
    const val = Math.max(0, parseInt(input.value||'0',10));
    changeQty(key,gid,val).catch(console.error);
  });
})();

